// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Amount$LiveRoom from "../../Amount.bs.js";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as LotTags$LiveRoom from "../../components/LotTags.bs.js";
import * as Utils_Lot$LiveRoom from "../../Utils/Utils_Lot.bs.js";
import * as LotSymbols$LiveRoom from "../../components/LotSymbols.bs.js";
import * as PropSpread$LiveRoom from "../../components/PropSpread.bs.js";
import * as CommonStyles$LiveRoom from "../../styles/CommonStyles.bs.js";
import * as Utils_Shared$LiveRoom from "../../Utils/Utils_Shared.bs.js";
import * as LotCardTagline$LiveRoom from "../../components/LotCardTagline.bs.js";
import * as SterlingTokens$LiveRoom from "../../bindings/SterlingTokens.bs.js";
import * as StyleConstants$LiveRoom from "../../styles/StyleConstants.bs.js";
import * as ClientapiQueries$LiveRoom from "../../ClientapiQueries.bs.js";
import * as LotCardIndicator$LiveRoom from "../../components/LotCardIndicator.bs.js";
import * as SterlingTypography$LiveRoom from "../../bindings/SterlingTypography.bs.js";
import * as AlternativeCurrency$LiveRoom from "../../stores/AlternativeCurrency.bs.js";

function textEllipsis(maxLines) {
  return Curry._1(Css.style, {
              hd: Css.overflow("hidden"),
              tl: {
                hd: Css.wordWrap("breakWord"),
                tl: {
                  hd: Css.unsafe("wordBreak", "break-word"),
                  tl: {
                    hd: Css.unsafe("WebkitLineClamp", "calc(" + String(maxLines) + ")"),
                    tl: {
                      hd: Css.unsafe("display", "-webkit-box"),
                      tl: {
                        hd: Css.unsafe("WebkitBoxOrient", "vertical"),
                        tl: {
                          hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                                hd: Css.unsafe("WebkitLineClamp", "calc(1)"),
                                tl: /* [] */0
                              }),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }
              }
            });
}

function CurrentLotCard$LotTitleWrapper$Primary(props) {
  var numberOfLines = props.numberOfLines;
  var numberOfLines$1 = numberOfLines !== undefined ? numberOfLines : 1;
  return React.createElement(PropSpread$LiveRoom.make, {
              data: {
                hd: {
                  TAG: /* TestId */1,
                  _0: "lotTitle"
                },
                tl: /* [] */0
              },
              children: React.createElement(SterlingTypography$LiveRoom.Headline20Regular.make, {
                    className: Curry._1(Css.merge, {
                          hd: Curry._1(Css.style, {
                                hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                                tl: /* [] */0
                              }),
                          tl: {
                            hd: textEllipsis(numberOfLines$1),
                            tl: /* [] */0
                          }
                        }),
                    children: props.children
                  })
            });
}

var Primary = {
  make: CurrentLotCard$LotTitleWrapper$Primary
};

function CurrentLotCard$LotTitleWrapper$Secondary(props) {
  return React.createElement(PropSpread$LiveRoom.make, {
              data: {
                hd: {
                  TAG: /* TestId */1,
                  _0: "lotSubTitle"
                },
                tl: /* [] */0
              },
              children: React.createElement(SterlingTypography$LiveRoom.Label16Medium.make, {
                    className: Curry._1(Css.merge, {
                          hd: Curry._1(Css.style, {
                                hd: Css.important(Css.fontWeight({
                                          NAME: "num",
                                          VAL: StyleConstants$LiveRoom.book
                                        })),
                                tl: {
                                  hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                                  tl: /* [] */0
                                }
                              }),
                          tl: {
                            hd: textEllipsis(2),
                            tl: /* [] */0
                          }
                        }),
                    children: props.children
                  })
            });
}

var Secondary = {
  make: CurrentLotCard$LotTitleWrapper$Secondary
};

function CurrentLotCard$LotTitleWrapper$LotTitleAndCreator(props) {
  var creatorsName = Utils_Lot$LiveRoom.lotCreators(props.creatorPrefix, props.creators);
  return React.createElement(React.Fragment, undefined, React.createElement(CurrentLotCard$LotTitleWrapper$Primary, {
                  children: "" + props.lotNr + " " + creatorsName + ""
                }), React.createElement(CurrentLotCard$LotTitleWrapper$Secondary, {
                  children: props.title
                }));
}

var LotTitleAndCreator = {
  make: CurrentLotCard$LotTitleWrapper$LotTitleAndCreator
};

function CurrentLotCard$LotTitleWrapper(props) {
  var creators = props.creators;
  var lotNr = props.lotNr;
  var subtitle = props.subtitle;
  var title = props.title;
  var creators$1 = props.useCreatorSplit && Caml_obj.notequal(creators, []) ? creators : undefined;
  if (creators$1 !== undefined) {
    return React.createElement(CurrentLotCard$LotTitleWrapper$LotTitleAndCreator, {
                title: title,
                lotNr: lotNr,
                creators: creators$1,
                creatorPrefix: props.creatorPrefix
              });
  } else if (subtitle !== undefined) {
    return React.createElement(React.Fragment, undefined, React.createElement(CurrentLotCard$LotTitleWrapper$Primary, {
                    children: title
                  }), React.createElement(CurrentLotCard$LotTitleWrapper$Secondary, {
                    children: subtitle
                  }));
  } else {
    return React.createElement(CurrentLotCard$LotTitleWrapper$Primary, {
                children: "" + lotNr + " " + title + "",
                numberOfLines: 3
              });
  }
}

var LotTitleWrapper = {
  textEllipsis: textEllipsis,
  Primary: Primary,
  Secondary: Secondary,
  LotTitleAndCreator: LotTitleAndCreator,
  make: CurrentLotCard$LotTitleWrapper
};

function CurrentLotCard$Estimate$EstimateUponRequest(props) {
  return React.createElement(PropSpread$LiveRoom.make, {
              data: {
                hd: {
                  TAG: /* TestId */1,
                  _0: "estimateUponRequest"
                },
                tl: /* [] */0
              },
              children: React.createElement(SterlingTypography$LiveRoom.Paragraph14Regular.make, {
                    children: Curry._1(props.t, "Common_lotEstimateUponRequest")
                  })
            });
}

var EstimateUponRequest = {
  make: CurrentLotCard$Estimate$EstimateUponRequest
};

function CurrentLotCard$Estimate$LotEstimate(props) {
  var lowEstimate = props.lowEstimate;
  var highEstimate = props.highEstimate;
  var match = lowEstimate.currency;
  var match$1 = highEstimate.currency;
  var currency = match !== undefined ? Amount$LiveRoom.currencyToString(match) : (
      match$1 !== undefined ? Amount$LiveRoom.currencyToString(match$1) : ""
    );
  var lowEstimateString = Utils_Shared$LiveRoom.Numbers.withCommas(lowEstimate.amount);
  var highEstimateString = Utils_Shared$LiveRoom.Numbers.withCommas(highEstimate.amount);
  var alternativeCurrency = Curry._1(AlternativeCurrency$LiveRoom.Context.use, undefined);
  var isAlternativeCurrencyVisible = Belt_Option.isSome(alternativeCurrency) && !props.isLotClosed;
  var estimatesString = "" + lowEstimateString + " - " + highEstimateString + " " + currency + "";
  var tmp;
  if (isAlternativeCurrencyVisible && alternativeCurrency !== undefined) {
    var rate = alternativeCurrency.rate;
    var convertedLowEstimate = AlternativeCurrency$LiveRoom.formatAlternativeCurrency(lowEstimate.amount, rate);
    var convertedHighEstimate = AlternativeCurrency$LiveRoom.formatAlternativeCurrency(highEstimate.amount, rate);
    var currency$1 = Amount$LiveRoom.currencyToString(alternativeCurrency.currency);
    tmp = React.createElement(PropSpread$LiveRoom.make, {
          data: {
            hd: {
              TAG: /* TestId */1,
              _0: "AlternativeCurrencyEstimate"
            },
            tl: /* [] */0
          },
          children: React.createElement(SterlingTypography$LiveRoom.Paragraph12Regular.make, {
                className: Curry._1(Css.style, {
                      hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey80_nohashtag)),
                      tl: /* [] */0
                    }),
                children: "" + convertedLowEstimate + " - " + convertedHighEstimate + " " + currency$1 + ""
              })
        });
  } else {
    tmp = null;
  }
  return React.createElement(React.Fragment, undefined, React.createElement(SterlingTypography$LiveRoom.Paragraph12Regular.make, {
                  className: Curry._1(Css.style, {
                        hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey80_nohashtag)),
                        tl: {
                          hd: Css.display("none"),
                          tl: {
                            hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                                  hd: Css.display("block"),
                                  tl: /* [] */0
                                }),
                            tl: /* [] */0
                          }
                        }
                      }),
                  children: estimatesString
                }), React.createElement(PropSpread$LiveRoom.make, {
                  data: {
                    hd: {
                      TAG: /* TestId */1,
                      _0: "estimateValueText"
                    },
                    tl: /* [] */0
                  },
                  children: React.createElement(SterlingTypography$LiveRoom.Paragraph14Regular.make, {
                        className: Curry._1(Css.style, {
                              hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                                    hd: Css.display("none"),
                                    tl: /* [] */0
                                  }),
                              tl: /* [] */0
                            }),
                        children: estimatesString
                      })
                }), tmp);
}

var LotEstimate = {
  make: CurrentLotCard$Estimate$LotEstimate
};

function CurrentLotCard$Estimate(props) {
  var estimate = props.estimate;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  var variant = estimate.NAME;
  var tmp;
  if (variant === "LowHighEstimateV2") {
    var match$1 = estimate.VAL;
    tmp = React.createElement(CurrentLotCard$Estimate$LotEstimate, {
          highEstimate: match$1.highEstimate,
          lowEstimate: match$1.lowEstimate,
          isLotClosed: props.isLotClosed
        });
  } else {
    tmp = variant === "FutureAddedValue" ? null : React.createElement(CurrentLotCard$Estimate$EstimateUponRequest, {
            t: t
          });
  }
  return React.createElement(React.Fragment, undefined, React.createElement(SterlingTypography$LiveRoom.Paragraph12Regular.make, {
                  className: Curry._1(Css.style, {
                        hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey80_nohashtag)),
                        tl: {
                          hd: Css.marginBottom(Css.px(8)),
                          tl: {
                            hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                                  hd: Css.paddingRight(Css.px(16)),
                                  tl: {
                                    hd: Css.marginBottom("zero"),
                                    tl: /* [] */0
                                  }
                                }),
                            tl: /* [] */0
                          }
                        }
                      }),
                  children: Curry._1(t, "AuctionRoomPage_estimate")
                }), tmp);
}

var Estimate = {
  EstimateUponRequest: EstimateUponRequest,
  LotEstimate: LotEstimate,
  make: CurrentLotCard$Estimate
};

function CurrentLotCard$LotBidState(props) {
  var bidState = props.bidState;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  var match$1 = bidState.currentBid;
  var match$2 = bidState.startingBid;
  var match$3 = match$1 !== undefined ? [
      match$1.amount,
      match$1.currency
    ] : (
      match$2 !== undefined ? [
          match$2.amount,
          match$2.currency
        ] : [
          undefined,
          undefined
        ]
    );
  var bidAmount = match$3[0];
  var alternativeCurrency = Curry._1(AlternativeCurrency$LiveRoom.Context.use, undefined);
  var match$4 = bidState.bidType;
  var tmp;
  if (typeof match$4 === "object" && match$4.NAME === "LiveBidType") {
    var match$5 = match$4.VAL;
    var match$6 = match$5.liveBidPhase;
    var exit = 0;
    if (match$6 === "Closed") {
      tmp = Curry._1(t, "FeedHeaderBid_finalBid");
    } else if ((match$6 === "Upcoming" || match$6 === "Published") && match$5.bidMethod === "Absentee") {
      tmp = Curry._1(t, "FeedHeaderBid_startingBid");
    } else {
      exit = 1;
    }
    if (exit === 1) {
      tmp = match$6 === "Live" || match$6 === "AcceptingBids" || match$6 === "ConfirmingResult" || match$6 === "Upcoming" ? (
          Belt_Option.isSome(bidState.currentBid) ? Curry._1(t, "FeedHeaderBid_currentBid") : Curry._1(t, "FeedHeaderBid_startingBid")
        ) : null;
    }
    
  } else {
    tmp = null;
  }
  var tmp$1;
  if (bidAmount !== undefined) {
    var bidAmount$1 = Utils_Shared$LiveRoom.Numbers.withCommas(bidAmount);
    var currency = Amount$LiveRoom.currencyToString(match$3[1]);
    tmp$1 = "" + bidAmount$1 + " " + currency + "";
  } else {
    tmp$1 = "---";
  }
  var tmp$2;
  if (bidAmount !== undefined && alternativeCurrency !== undefined && !bidState.isClosed) {
    var amount = AlternativeCurrency$LiveRoom.formatAlternativeCurrency(bidAmount, alternativeCurrency.rate);
    var currency$1 = Amount$LiveRoom.currencyToString(alternativeCurrency.currency);
    tmp$2 = React.createElement(PropSpread$LiveRoom.make, {
          data: {
            hd: {
              TAG: /* TestId */1,
              _0: "AlternativeCurrencyLotBidState"
            },
            tl: /* [] */0
          },
          children: React.createElement(SterlingTypography$LiveRoom.Paragraph12Regular.make, {
                className: Curry._1(Css.style, {
                      hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey80_nohashtag)),
                      tl: /* [] */0
                    }),
                children: "" + amount + " " + currency$1 + ""
              })
        });
  } else {
    tmp$2 = null;
  }
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                          hd: Css.display("none"),
                          tl: /* [] */0
                        }),
                    tl: /* [] */0
                  })
            }, React.createElement(SterlingTypography$LiveRoom.Paragraph12Regular.make, {
                  className: Curry._1(Css.style, {
                        hd: Css.marginBottom(Css.px(8)),
                        tl: {
                          hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey80_nohashtag)),
                          tl: /* [] */0
                        }
                      }),
                  children: tmp
                }), React.createElement(PropSpread$LiveRoom.make, {
                  data: {
                    hd: {
                      TAG: /* TestId */1,
                      _0: "lotBidStateAmount"
                    },
                    tl: /* [] */0
                  },
                  children: React.createElement(SterlingTypography$LiveRoom.Paragraph14Regular.make, {
                        children: tmp$1
                      })
                }), tmp$2);
}

var LotBidState = {
  make: CurrentLotCard$LotBidState
};

var fallbackBidState = {
  __typename: "BidState",
  id: "",
  isClosed: false,
  bidType: {
    NAME: "LiveBidType",
    VAL: {
      __typename: "LiveBidType",
      liveBidPhase: "Upcoming",
      bidMethod: "Absentee"
    }
  },
  currentBid: undefined,
  startingBid: undefined,
  sold: {
    NAME: "ResultVisible",
    VAL: {
      __typename: "ResultVisible",
      isSold: false,
      premiums: undefined
    }
  }
};

function CurrentLotCard(props) {
  var isMobile = props.isMobile;
  var lot = props.fragment;
  var isMobile$1 = isMobile !== undefined ? isMobile : false;
  var lotWithdrawn = lot.withdrawnState.state === "Withdrawn";
  var isLotClosed = Belt_Option.mapWithDefault(lot.bidState, false, (function (x) {
          return x.isClosed;
        }));
  var match = lot.lotNumber;
  var lotNr = typeof match === "object" && match.NAME === "VisibleLotNumber" ? match.VAL.lotNumber + "." : "";
  var tmp;
  if (isMobile$1) {
    tmp = null;
  } else {
    var match$1 = lot.bidState;
    var tmp$1;
    if (match$1 !== undefined) {
      var match$2 = match$1.bidType;
      tmp$1 = typeof match$2 === "object" && match$2.NAME === "LiveBidType" ? match$2.VAL.liveBidPhase : undefined;
    } else {
      tmp$1 = undefined;
    }
    tmp = React.createElement(LotCardTagline$LiveRoom.make, {
          isPremium: lot.premiumLotState.isPremium,
          userBid: lot.latestBid.bid,
          bidPhase: tmp$1,
          sold: Belt_Option.mapWithDefault(lot.bidState, {
                NAME: "ResultVisible",
                VAL: {
                  __typename: "ResultVisible",
                  isSold: false,
                  premiums: undefined
                }
              }, (function (bidState) {
                  return bidState.sold;
                }))
        });
  }
  var match$3 = LotCardIndicator$LiveRoom.getFlag(lot.latestBid.bid, lot.premiumLotState.isPremium, Belt_Array.some(Utils_Lot$LiveRoom.getTags(Belt_Option.getWithDefault(lot.lotTags, []), undefined), (function (tag) {
              return Caml_obj.equal(tag, /* NoReserve */0);
            })), false, false);
  return React.createElement(PropSpread$LiveRoom.make, {
              data: {
                hd: {
                  TAG: /* TestId */1,
                  _0: "lotTitleContainer"
                },
                tl: /* [] */0
              },
              children: React.createElement("div", {
                    className: Curry._1(Css.merge, {
                          hd: Curry._1(Css.style, {
                                hd: Css.display("flex"),
                                tl: {
                                  hd: Css.flexDirection("column"),
                                  tl: {
                                    hd: Css.minHeight(Css.px(264)),
                                    tl: {
                                      hd: StyleConstants$LiveRoom.defaultBorder("right", undefined, undefined),
                                      tl: {
                                        hd: Css.padding(Css.px(16)),
                                        tl: {
                                          hd: Css.position(Css.relative),
                                          tl: {
                                            hd: Css.opacity(lotWithdrawn ? 0.6 : 1.0),
                                            tl: {
                                              hd: Css.width(Css.pct(100)),
                                              tl: {
                                                hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                                                      hd: Css.width(Css.vw(100)),
                                                      tl: {
                                                        hd: Css.minHeight(Css.px(0)),
                                                        tl: {
                                                          hd: Css.padding3(Css.px(16), Css.px(16), "zero"),
                                                          tl: /* [] */0
                                                        }
                                                      }
                                                    }),
                                                tl: /* [] */0
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }),
                          tl: {
                            hd: props.isListHidden ? Curry._1(Css.style, {
                                    hd: Css.opacity(0.0),
                                    tl: /* [] */0
                                  }) : Curry._1(Css.style, {
                                    hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                                          hd: Css.border("zero", "none", "transparent"),
                                          tl: /* [] */0
                                        }),
                                    tl: /* [] */0
                                  }),
                            tl: /* [] */0
                          }
                        }),
                    id: "lotTitleContainer"
                  }, Belt_Option.getWithDefault(props.carousel, null), tmp, React.createElement(CurrentLotCard$LotTitleWrapper, {
                        title: lot.title,
                        subtitle: lot.subtitle,
                        lotNr: lotNr,
                        creators: lot.creatorsDisplayNames,
                        creatorPrefix: lot.creatorPrefix,
                        useCreatorSplit: lot.auction.useCreatorSplit
                      }), lot.symbolsV2.length !== 0 ? React.createElement("div", {
                          className: Curry._1(Css.style, {
                                hd: Css.margin2(Css.px(16), Css.px(0)),
                                tl: /* [] */0
                              })
                        }, React.createElement(LotSymbols$LiveRoom.make, {
                              lotSymbols: lot.symbolsV2,
                              height: "20px"
                            })) : null, React.createElement(LotTags$LiveRoom.make, {
                        tags: Utils_Lot$LiveRoom.getTags(Belt_Option.getWithDefault(lot.lotTags, []), Belt_Option.map(lot.parcel, (function (x) {
                                    return x.parcelName;
                                  })))
                      }), React.createElement("div", {
                        className: Curry._1(Css.merge, {
                              hd: Curry._1(Css.style, {
                                    hd: Css.marginTop(Css.px(16)),
                                    tl: {
                                      hd: Css.display("flex"),
                                      tl: {
                                        hd: Css.justifyContent("spaceBetween"),
                                        tl: {
                                          hd: Css.minWidth(Css.px(0)),
                                          tl: {
                                            hd: CommonStyles$LiveRoom.mediaV2(/* DesktopAndTabletLandscape */4, {
                                                  hd: Css.marginTop("auto"),
                                                  tl: /* [] */0
                                                }),
                                            tl: {
                                              hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                                                    hd: Css.marginTop(Css.px(8)),
                                                    tl: /* [] */0
                                                  }),
                                              tl: /* [] */0
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }),
                              tl: /* [] */0
                            })
                      }, React.createElement("div", {
                            className: Curry._1(Css.style, {
                                  hd: Css.marginRight(Css.px(16)),
                                  tl: {
                                    hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                                          hd: Css.display("flex"),
                                          tl: /* [] */0
                                        }),
                                    tl: /* [] */0
                                  }
                                })
                          }, React.createElement(CurrentLotCard$Estimate, {
                                estimate: lot.estimate,
                                isLotClosed: isLotClosed
                              })), React.createElement(CurrentLotCard$LotBidState, {
                            bidState: Belt_Option.getWithDefault(lot.bidState, fallbackBidState)
                          })), match$3 !== undefined && isMobile$1 ? React.createElement(LotCardIndicator$LiveRoom.Flag.make, {
                          flag: match$3[0],
                          size: /* ExtraLarge */2
                        }) : null)
            });
}

var BidStateFragment = ClientapiQueries$LiveRoom.CurrentLotCard.BidStateFragment;

var LatestUserBid = ClientapiQueries$LiveRoom.CurrentLotCard.LatestUserBid;

var PremiumLotStateFragment = ClientapiQueries$LiveRoom.CurrentLotCard.PremiumLotStateFragment;

var LotSymbolFragment = ClientapiQueries$LiveRoom.CurrentLotCard.LotSymbolFragment;

var CurrentLotCardLotFragment = ClientapiQueries$LiveRoom.CurrentLotCard.CurrentLotCardLotFragment;

var makeAuction = ClientapiQueries$LiveRoom.CurrentLotCard.makeAuction;

var defaultAuction = ClientapiQueries$LiveRoom.CurrentLotCard.defaultAuction;

var defaultLotNumber = ClientapiQueries$LiveRoom.CurrentLotCard.defaultLotNumber;

var defaultPremiumLotState = ClientapiQueries$LiveRoom.CurrentLotCard.defaultPremiumLotState;

var defaultWithdrawnState = ClientapiQueries$LiveRoom.CurrentLotCard.defaultWithdrawnState;

var estimateUponRequest = ClientapiQueries$LiveRoom.CurrentLotCard.estimateUponRequest;

var makeLowHighEstimate = ClientapiQueries$LiveRoom.CurrentLotCard.makeLowHighEstimate;

var makeBidType = ClientapiQueries$LiveRoom.CurrentLotCard.makeBidType;

var makeBidStateFragment = ClientapiQueries$LiveRoom.CurrentLotCard.makeBidStateFragment;

var makeLotFragment = ClientapiQueries$LiveRoom.CurrentLotCard.makeLotFragment;

var make = CurrentLotCard;

export {
  BidStateFragment ,
  LatestUserBid ,
  PremiumLotStateFragment ,
  LotSymbolFragment ,
  CurrentLotCardLotFragment ,
  makeAuction ,
  defaultAuction ,
  defaultLotNumber ,
  defaultPremiumLotState ,
  defaultWithdrawnState ,
  estimateUponRequest ,
  makeLowHighEstimate ,
  makeBidType ,
  makeBidStateFragment ,
  makeLotFragment ,
  LotTitleWrapper ,
  Estimate ,
  LotBidState ,
  fallbackBidState ,
  make ,
}
/* Css Not a pure module */
